var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"elevation":"0","x-small":"","color":"primary"},on:{"click":function($event){return _vm.$emit('remove')}}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v(" mdi-close ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }